import React, { useEffect } from 'react'
import { connect, ConnectedProps, useSelector } from 'react-redux'

import { bindActionCreators } from 'redux'

import LoadingIndicator from '@lyrahealth-inc/ui-core/lib/atoms/loadingIndicator/LoadingIndicator'
import ContentLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/ContentLayout'
import CardMedium from '@lyrahealth-inc/ui-core/lib/molecules/layouts/cardMedium/CardMedium'

import * as myPracticeInfoActions from './data/myPracticeInfoActions'
import DisplayPracticeInfo from './DisplayPracticeInfo'
import styles from './myPracticeInfo.module.scss'
import { SET_MY_INFO_DATA } from '../../common/constants/reduxConstants'
import { hasErrorForAction } from '../../common/utils/utils'
import { getAlertsState } from '../../data/alertsSelectors'
import { Alert } from '../../data/alertTypes'
import { getAuthPracticeId } from '../../data/auth/authSelectors'
import { getMyInfoData } from '../data/myInfoSelectors'

type MyPracticeInfoProps = ConnectedProps<typeof connector>
const MyPracticeInfo = ({ actions: { returnPracticeInfo } }: MyPracticeInfoProps) => {
  const id = useSelector(getAuthPracticeId)
  const myPracticeInfo = useSelector(getMyInfoData)
  const alerts: Alert[] = useSelector(getAlertsState)
  useEffect(() => {
    returnPracticeInfo(id)
  }, [id, returnPracticeInfo])

  if (!myPracticeInfo) {
    if (hasErrorForAction(alerts, SET_MY_INFO_DATA)) {
      return null // custom workflow or display could render here
    } else {
      return (
        <div className={styles['loading-container']}>
          <LoadingIndicator size={45} />
        </div>
      )
    }
  }
  return (
    <ContentLayout>
      <CardMedium>
        <div>
          <h1 className={styles.title}>My Practice Info</h1>
          <DisplayPracticeInfo $$data={myPracticeInfo as unknown as Dict} />
        </div>
      </CardMedium>
    </ContentLayout>
  )
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    actions: bindActionCreators({ ...myPracticeInfoActions }, dispatch),
  }
}
const connector = connect(null, mapDispatchToProps)

export default connector(MyPracticeInfo)
